export default [
    {
        name: 'alxislandModel',
        type: 'gltfModel',
        path: './models/alxisland.gltf'
    },
    {
        name: 'environmentMap',
        type: 'hdrTexture',
        path: './textures/hdr/sky.hdr'
    },
    // Cover textures for screens
    {
        name: 'aboutcoverTexture',
        type: 'texture',
        path: './textures/screens/about/aboutcover.png'
    },
    {
        name: 'projectscoverTexture',
        type: 'texture',
        path: './textures/screens/projects/projectscover.png'
    },
    {
        name: 'creditscoverTexture',
        type: 'texture',
        path: './textures/screens/creditscover.png'
    },
    // About Me Screen Textures
    {
        name: 'aboutMainTexture',
        type: 'texture',
        path: './textures/screens/about/about.png'
    },
    {
        name: 'aboutSkillsTexture',
        type: 'texture',
        path: './textures/screens/about/skills.png'
    },
    {
        name: 'aboutExperienceTexture',
        type: 'texture',
        path: './textures/screens/about/experience.png'
    },
    // Projects Screen Textures
    {
        name: 'projectsMainTexture',
        type: 'texture',
        path: './textures/screens/projects/project.png'  // Main grid with 8 projects
    },
    // Individual project pages
    {
        name: 'project1Texture',
        type: 'texture',
        path: './textures/screens/projects/project1.png'
    },
    {
        name: 'project2Texture',
        type: 'texture',
        path: './textures/screens/projects/project2.png'
    },
    {
        name: 'project3Texture',
        type: 'texture',
        path: './textures/screens/projects/project3.png'
    },
    {
        name: 'project4Texture',
        type: 'texture',
        path: './textures/screens/projects/project4.png'
    },
    {
        name: 'project5Texture',
        type: 'texture',
        path: './textures/screens/projects/project5.png'
    },
    {
        name: 'project6Texture',
        type: 'texture',
        path: './textures/screens/projects/project6.png'
    },
    {
        name: 'project7Texture',
        type: 'texture',
        path: './textures/screens/projects/project7.png'
    },
    {
        name: 'project8Texture',
        type: 'texture',
        path: './textures/screens/projects/project8.png'
    },
    // Credits Screen
    {
        name: 'creditsTexture',
        type: 'texture',
        path: './textures/screens/credits.png'
    }
]